import React, { useEffect, useState } from 'react';

import '../styles/Home.css';
import '../styles/About.css';
import '../styles/Responsive.css';

import Footer from '../components/Footer.js';
import axiosPost from '../helper/axios-helper.js';

export default function About() {
    const [selectedIndex, setSelectedIndex] = useState(0); 
    const [timelines, setHistory] = useState([]);
    const [modalTimeline, setModalTimeline] = useState(null);

    const [ image, setImage ] = useState('');

    useEffect(() => {
        fetchContent()
    }, [])

    const fetchContent = () => {

        axiosPost('content/fetch', {}, {page: 'about_mission'}, (data) => {

        const { success, response } = data;

        if (success) {
            
            setImage(data.data.image)
            

        } else {
            
        }

        })

    }

    const fetchHistory = () => {
        
        axiosPost('about/history/fetch', {}, {}, (data) => {
            const { success, response } = data;
            if (success) {
                setHistory(data.data);
            }
        })
    }

    useEffect(() => {
        fetchHistory();
        fetchContent();
    }, [])

   // Track if user has manually selected a timeline item
   const [userHasInteracted, setUserHasInteracted] = useState(false);
   
   // Only scroll when user has manually selected an item
   useEffect(() => {
        if (!userHasInteracted) return;
        
        const selectedElement = document.querySelector('.timeline-container.selected');
        if (selectedElement) {
            selectedElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }, [selectedIndex, userHasInteracted]);
    
   const getPreviewHTML = (htmlText) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlText;
        const plainText = tempDiv.textContent || tempDiv.innerText || '';
        
        const words = plainText.split(' ');
        const previewWords = words.slice(0, 20).join(' ');
        
        if (words.length <= 20) {
            return htmlText;
        }
        
        return previewWords + '...';
    };

    const openModal = (timeline, e) => {
        e.stopPropagation();
        setModalTimeline(timeline);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setModalTimeline(null);
        document.body.style.overflow = '';
    };

   function renderHistoryTimeline(){

    const render_items = timelines.map((timeline, index) => {
        const isSelected = selectedIndex === index;
        const previewHTML = getPreviewHTML(timeline.text);
        const hasMore = previewHTML !== timeline.text;
        
        return (
            <div 
                key={timeline.id}
                className={`timeline-container ${isSelected ? 'selected' : ''}`} 
                onClick={() => {
                    setSelectedIndex(index);
                    setUserHasInteracted(true);
                }}
            >
                <div className='timeline-header-container'>
                    <div className={`timeline-header-circle ${isSelected ? 'selected' : ''}`}></div>
                    <div className={`timeline-header-year ${isSelected ? 'selected' : ''}`}>
                        {timeline.year}
                    </div>
                    <div className='timeline-header-text'>
                        {timeline.title}
                    </div>
                </div>

                <div className='timeline-image-container'>
                    <img 
                        className='timeline-image' 
                        src={timeline.image} 
                        alt={`${timeline.year} - ${timeline.title}`}
                        loading="lazy"
                        draggable={false}
                    />
                </div>

                <div className='timeline-text'>
                    <div dangerouslySetInnerHTML={{ __html: previewHTML }} />
                    {hasMore && (
                        <button 
                            className='timeline-read-more-btn'
                            onClick={(e) => openModal(timeline, e)}
                        >
                            Read more
                        </button>
                    )}
                </div>
            </div>
        );
    });

    return render_items;
}
    
  return (
    <div className='container' style={{paddingTop: '100px'}}>

        <div className='about-vision-container'>
            <div className='about-vision-text-container'>
                <div className='about-vision-item'>
                    <div className='about-vision-item-title'>
                        Our <span>Mission</span>
                        <div className='about-vision-item-bar'></div>
                    </div>
                    <div className='about-vision-item-text'>To drive ICT innovation and collaboration across the Caribbean, fostering regional development through telecommunications excellence.</div>
                </div>
                <div className='about-vision-item alt'>
                    <div className='about-vision-item-title alt'>
                        And <span>Vision.</span>
                        <div className='about-vision-item-bar alt'></div>
                    </div>
                    <div className='about-vision-item-text'>A connected Caribbean at the forefront of global ICT advancements, empowering communities and businesses through cutting-edge telecommunications solutions.</div>
                </div>
            </div>
            <div className='about-vision-video-container' style={{backgroundImage: `url(${image})`}}>
                {/* <video style={{height: '100%', width: '100%'}} controls autoPlay loop>
                    <source src={process.env.PUBLIC_URL + '/assets/videos/conference.mp4'} type='video/mp4'/>
                </video> */}
            </div>
        </div>

        <div className='about-history-container'>
            <div className='about-history-header'>History</div>
            <div className='about-history-items-container' style={{marginTop: '50px'}}>
                { renderHistoryTimeline() }
            </div>
        </div>

        {/* Timeline Modal */}
        {modalTimeline && (
            <div className='timeline-modal-overlay' onClick={closeModal}>
                <div className='timeline-modal' onClick={(e) => e.stopPropagation()}>
                    <button className='timeline-modal-close' onClick={closeModal}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="18" y1="6" x2="6" y2="18"/>
                            <line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                    </button>
                    
                    <div className='timeline-modal-content'>
                        <div className='timeline-modal-header'>
                            <div className='timeline-modal-year'>{modalTimeline.year}</div>
                            <h2 className='timeline-modal-title'>{modalTimeline.title}</h2>
                        </div>
                        
                        <div className='timeline-modal-image-container'>
                            <img 
                                src={modalTimeline.image} 
                                alt={`${modalTimeline.year} - ${modalTimeline.title}`}
                                className='timeline-modal-image'
                            />
                        </div>
                        
                        <div className='timeline-modal-text' dangerouslySetInnerHTML={{ __html: modalTimeline.text }} />
                    </div>
                </div>
            </div>
        )}

    </div>
  )
}
